import { connect } from "react-redux";

import {
	updateField,
	storeCaptcha,
	validateField,
	setCurrentField,
	dismissSuggestion,
	submitRegistration,
	redirectToOnboarding,
	setCaptchaV3Token,
} from "ducks/signup";
import { confirmToken } from "ducks/recaptcha";
import App from "apps/signup/components/App";

function mapStateToProps(state) {
	const { signup } = state;
	return signup;
}

const mapDispatchToProps = {
	updateField,
	validate: validateField,
	storeCaptcha,
	setCurrentField,
	submitRegistration,
	dismissSuggestion,
	redirectToOnboarding,
	confirmRecaptchaToken: confirmToken,
	setCaptchaV3Token,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/apps/signup/index.js